import React, { useEffect } from "react";
import { observer } from "mobx-react";
import ConnectWhatsAppButton from "./ConnectWhatsAppButton";
import { whatsAppReplyState } from "./state";
import ConnectedWhatsAppList from "./ConnectedWhatsAppList";
import ConnectedWhatsAppConfigure from "./ConnectedWhatsAppConfigure";

const WA_CONNECTION_SUCCESS_MESSAGE = "wa-connection-success";

const WhatsAppAccounts = observer(() => {
  useEffect(() => {
    whatsAppReplyState.getCurrentTeam();
    whatsAppReplyState.setWaDataLoading(true);
    whatsAppReplyState.getWhatsappAccounts();
  }, []);

  useEffect(() => {
    const onMessage = (event) => {
      if (event.origin !== window.location.origin || event.data !== WA_CONNECTION_SUCCESS_MESSAGE) return;
      whatsAppReplyState.getWhatsappAccounts();
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return (
    <div
      className={`connectLinkedInBody ${
        whatsAppReplyState?.waConnected ? "linkedInAccountConnected" : ""
      }`}
    >
      {whatsAppReplyState?.waConnected ? (
        whatsAppReplyState?.showConfigure ? (
          <ConnectedWhatsAppConfigure />
        ) : (
          <div className="connectedLinkedInAccountsBody">
            <ConnectedWhatsAppList />
          </div>
        )
      ) : (
        <ConnectWhatsAppButton />
      )}
    </div>
  );
});

export { WhatsAppAccounts };
export default WhatsAppAccounts;
